<style>

    .submission-box > .el-dialog > .el-dialog__header {
        -webkit-box-shadow: none;
        box-shadow: none;
        padding-bottom: 0;
        padding: 0;
    }

    .submission-box > .el-dialog > .el-dialog__header > .el-dialog__headerbtn {
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 0;
        background: #1e1d1d;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 24px;
        font-weight: bold;
        z-index: 10;
    }

    .submission-box > .el-dialog {
        top: 8vh;
        max-width: 1300px;
        background-color: rgb(244, 245, 247);
    }

    .ck .ck-balloon-panel {
        z-index: 9999 !important;
    }
</style>

<template>
    <submission-page-content :key="key"></submission-page-content>
</template>

<script>

    import SubmissionPageContent from "./SubmissionPageContent";

    export default {
        components: {SubmissionPageContent},

        data() {
            return {
                key: 0
            };
        },

        beforeRouteEnter(to, from, next) {
            if (
                typeof Store.page.channel.temp.name != "undefined" &&
                Store.page.channel.temp.name != to.params.name
            ) {
                Store.page.submission.clearSubmission();
            }

            if (typeof app != "undefined") {
                app.$Progress.start();
            }

            Store.page.submission
                .getSubmission(to.params.slug)
                .then(() => {
                    next(vm => {
                        vm.$Progress.finish();
                    });
                })
                .catch(error => {
                    // if (error.response.status === 404) {
                    // 	this.$router.push('/404')
                    // }
                });
        },

        beforeRouteLeave(to, from, next) {
            Echo.leave("submission." + from.params.slug);
            next();
        },

        beforeRouteUpdate(to, from, next) {
            if (to.hash !== from.hash) return;

            Store.page.submission.clearSubmission();
            this.$Progress.start();

            Store.page.submission
                .getSubmission(to.params.slug)
                .then(() => {
                    Echo.leave("submission." + from.params.slug);
                    this.$Progress.finish();

                    next();
                })
                .catch(error => {
                    // if (error.response.status === 404) {
                    // 	this.$router.push('/404')
                    // }

                    this.$Progress.fail();
                });
        },
        created() {
            this.$eventHub.$on("reRender", () => {
                this.key++
            });
        },

        methods: {
            close() {
                this.$router.go(-1)
            },
        },

    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SubmissionPage.vue